import { useState } from 'react';
import {
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import pMap from 'p-map';
import { Dialog } from '../../components/Dialog';
import * as api from '../../lib/api';

export default function UncertifyConfirmation(props) {
  const { handleClose, handleUncertified } = props;
  const [fields, setFields] = useState(props.fields);

  return (
    <Dialog
      width="sm"
      title="Uncertify Fields"
      onCancel={handleClose}
      canSave
      onSave={onSave}
    >
      <Typography sx={{ mb: 2 }} typography="body1">
        Uncertifying will result in a temporary loss of previously uploaded
        data.
      </Typography>
      <Typography sx={{ mb: 2 }} variant="body1">
        In order to repopulate that data after recertification, please reach out
        to{' '}
        <a href="mailto:help@advancedagrilytics.com">
          help@advancedagrilytics.com
        </a>{' '}
        with details of edits you've made.
      </Typography>
      <Typography sx={{ mb: 1 }} variant="body1">
        Are you sure you want to uncertify the following fields?
      </Typography>
      <List dense>
        {fields.map((field) => (
          <ListItem sx={{ p: 0 }} key={field.aaManagedId}>
            {field.uncertifying ? (
              <CircularProgress sx={{ mr: 1 }} size={12} color="inherit" />
            ) : null}
            <ListItemText sx={{ m: 0 }} primary={field.fieldName} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );

  async function onSave() {
    try {
      const results = await pMap(fields, uncertifyOne, { concurrency: 3 });
      handleUncertified({ results: results.flat() });
    } catch (error) {
      handleUncertified({ error });
    }
  }

  async function uncertifyOne(field) {
    setFields((current) =>
      current.map((f) => {
        if (f.aaManagedId !== field.aaManagedId) return f;
        return { ...f, uncertifying: true };
      }),
    );

    return api.uncertifyFields([field]).finally(() => {
      setFields((current) =>
        current.filter((f) => f.aaManagedId !== field.aaManagedId),
      );
    });
  }
}
